
define('txt!modules/module.paginator.pma.hbs',[],function () { return '{{!-- see paginator.js note: cannot use datalayer-link class here, need to manually build and fire via module.dealers.js --}}\r\n<a href="{{this.action.url}}" class="btn-mod btn-mod-grey-dark module-page-all">{{this.action.title}}</a>\r\n';});

